/**
 * Column geometry for the trade equipment table, shared by the header
 * (TradeAccordion) and the rows (EquipmentRow) so the two can never drift.
 *
 * The table has a fixed minimum width and scrolls horizontally inside its own
 * container rather than collapsing responsively: once a table has column
 * headers, stacking the cells on mobile orphans the headers and the columns
 * stop meaning anything.
 */

/**
 * Column order: Équipement · État · Mise en service · Maintenance · Garantie ·
 * Vérifications · Nombre. The minimums add up to ~680px: the Vérifications
 * column prints two dates, so on the asset page's narrowest desktop layout
 * (content card next to the open details sidebar) the table scrolls inside its
 * container, and the `fr` shares take the slack on wider viewports.
 */
export const EQUIPMENT_TABLE_GRID =
  'grid grid-cols-[minmax(130px,3fr)_minmax(80px,1.2fr)_minmax(104px,1.2fr)_76px_68px_112px_56px] gap-2'

/**
 * Minimum table width — below this (mobile) the container scrolls
 * horizontally rather than the page doing so.
 */
export const EQUIPMENT_TABLE_MIN_WIDTH = 'min-w-[680px]'

/** Header cell styling, matching the canonical `TableHead` (ui/table.tsx). */
export const EQUIPMENT_TABLE_HEAD_CELL = 'truncate text-xs font-medium text-muted-foreground'
